import type { ColumnMetadata } from '../grid/types';

export type EmployeeReviewPeriodJsMethodOptions = {
  periodToIdElement: string;
};

const decodeLegacyJson = (value: string): string => value.replace(/&quot;|&#34;|&#x22;/gi, '"');

export const parseEmployeeReviewPeriodJsMethodOptions = (
  rawOptions: string | null | undefined
): EmployeeReviewPeriodJsMethodOptions | null => {
  if (!rawOptions) return null;

  try {
    const options = JSON.parse(
      decodeLegacyJson(rawOptions)
    ) as Partial<EmployeeReviewPeriodJsMethodOptions>;
    const periodToIdElement = options.periodToIdElement?.trim();
    return periodToIdElement ? { periodToIdElement } : null;
  } catch {
    return null;
  }
};

export const resolveEmployeeReviewPeriodFieldName = (
  fields: ColumnMetadata[],
  identifier: string
): string | null => {
  const normalizedIdentifier = identifier.replace(/^fld-ni-/i, '').toLowerCase();
  return (
    fields.find((field) =>
      [field.dataField, field.field, field.key]
        .filter(Boolean)
        .some((value) => value!.toLowerCase() === normalizedIdentifier)
    )?.dataField ?? null
  );
};
